import { Pipe, PipeTransform } from '@angular/core';
import { Template } from '../../models/template';

@Pipe({
  name: 'statsPipe',
  standalone: true
})
export class StatsPipe implements PipeTransform {

   xmlQuote(value: string): string {
    return `${value
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")}`;
  }

  clean(value: string): string {
    return value.replace(/[^a-zA-Z0-9]/g, '');
  }

  transform(value: Template, ...args: unknown[]): string {

    if (!value) return '';

    var n = this.xmlQuote(this.clean(value.name));
    var t = this.xmlQuote(value.test);
    var e = this.xmlQuote(value.eval);

    if (value.templateTypeId == '1bde4c04-c832-4b8b-9f32-911d80690c12') {
      return `<counter name="${n}" test="${t}"/>`;
    } else {
      return `<extractor basename="${n}" test="${t}" eval="${e}"/>`;
    }

  }

}
